import type { ApiNote, ChildNote } from '../types';

export const toChildNote = (api: ApiNote): ChildNote => ({
  id: api.id,
  author: api.employee.fullName,
  datetime: api.createdAt,
  body: api.content,
  isObservation: api.isQuestionnaireRelated,
});
